/* eslint-disable no-unused-vars */

export enum EmploymentType {
  FULL_TIME = 'Full time',
  PART_TIME = 'Part time',
  SELF_EMPLOYED = 'Self employed',
  OTHER = 'Other'
}

export enum Degree {
  BARCH = 'Bachelor of Architecture (BArch)',
  BA = 'Bachelor of Arts (BA, AB, BS, BSc, SB, ScB)',
  BAA = 'Bachelor of Applied Arts (BAA)',
  BAAS = 'Bachelor of Applied Arts and Science (BAAS)',
  BAPPSCIT = 'Bachelor of Applied Science in Information Technology (BAppSc(IT))',
  BDES = 'Bachelor of Design (BDes, or SDes in Indonesia)',
  BENG = 'Bachelor of Engineering (BEng, BE, BSE, BESc, BSEng, BASc, BTech, BSc(Eng), AMIE, GradIETE)',
  BSBBA = 'Bachelor of Science in Business (BSBA)',
  BSET = 'Bachelor of Engineering Technology (BSET)',
  BTECH = 'Bachelor of Technology (B.Tech. or B.Tech.)',
  BIBE = 'International Business Economics (BIBE)',
  BBA = 'Bachelor of Business Administration (BBA)',
  BMS = 'Bachelor of Management Studies (BMS)',
  BAS = 'Bachelor of Administrative Studies',
  BCOM = 'Bachelor of Commerce (BCom, or BComm)',
  BFA = 'Bachelor of Fine Arts (BFA)',
  BBUS = 'Bachelor of Business (BBus or BBus)',
  BMOS = 'Bachelor of Management and Organizational Studies (BMOS)',
  BBUSSC = 'Bachelor of Business Science (BBusSc)',
  BACC = 'Bachelor of Accountancy (B.Acy. or B.Acc. or B. Accty)',
  BCOMPT = 'Bachelor of Comptrolling (B.Acc.Sci. or B.Compt.)',
  BEC = 'Bachelor of Economics (BEc, BEconSc; sometimes BA(Econ) or BSc(Econ))',
  BAOM = 'Bachelor of Arts in Organizational Management (BAOM)',
  BCOMPSC = 'Bachelor of Computer Science (BCompSc)',
  BCOMP = 'Bachelor of Computing (BComp)'
}

export enum Role {
  ASPIRING_ENTREPRENEUR = 'Aspiring Entrepreneur',
  ENTREPRENEUR = 'Entrepreneur',
  MENTOR = 'Mentor',
  INVESTOR = 'Investor',
  SERVICE_PROVIDERS_STARTUP = 'Service providers/Startup',
  MENTOR_INVESTOR = 'Mentor and Investor'
}

export enum InviteMentorInvestorRoles {
  MENTOR = 'Mentor',
  INVESTOR = 'Investor',
  MENTOR_INVESTOR = 'Mentor and Investor'
}

export enum Expertise {
  BUSINESS_OPERATIONS = 'Business Operations',
  SUPPLY_CHAIN = 'Supply Chain',
  STRATEGY = 'Strategy',
  SALES_DISTRIBUTION = 'Sales & Distribution',
  DESIGN_THINKING = 'Design Thinking',
  ENTERPRISE_SALES = 'Enterprise Sales',
  FINANCIAL_MANAGEMENT = 'Financial Management',
  FUND_RAISING = 'Fund Raising',
  GO_TO_MARKET = 'Go-To-Market',
  LEGAL_COMPLIANCE = 'Legal / Compliance',
  MARKETING = 'Marketing',
  RESOURCE_MANAGEMENT = 'Resource Management',
  SAAS_STRATEGY = 'SaaS Strategy',
  LEADERSHIP = 'Leadership',
  TECHNOLOGY = 'Technology'
}

export enum Industries {
  ADDITIVE_MANUFACTURING = 'Additive Manufacturing (3D Printing)',
  ADVANCED_MATERIALS = 'Advanced Materials',
  AGRICULTURE = 'Agriculture',
  AGRITECH = 'Agriculture Technology (AgriTech)',
  AEROSPACE = 'Aerospace',
  ALTERNATIVE_PROTEINS = 'Alternative Proteins and Food Innovation',
  ARTIFICIAL_INTELLIGENCE = 'Artificial Intelligence (AI) and Machine Learning',
  AUGMENTED_AND_VIRTUAL_REALITY = 'Augmented Reality (AR) and Virtual Reality (VR)',
  AUGMENTED_REALITY_SHOPPING = 'Augmented Reality Shopping',
  AUDIO_AND_PODCASTING = 'Audio and Podcasting Platforms',
  AUTOMOTIVE = 'Automotive',
  BIG_DATA = 'Big Data',
  BIOINFORMATICS = 'Bioinformatics',
  BIOTECHNOLOGY = 'Biotechnology and Genetics',
  BLOCKCHAIN = 'Blockchain and Cryptocurrency',
  BLOCKCHAIN_FINANCE = 'Blockchain in Finance (DeFi)',
  CARBON_CAPTURE = 'Carbon Capture and Climate Tech',
  CLEANTECH = 'Cleantech',
  CLOUD_COMPUTING = 'Cloud Computing',
  COLD_CHAIN_SOLUTIONS = 'Cold Chain Solutions',
  CONSUMER_ELECTRONICS = 'Consumer Electronics',
  CORPORATE_TRAINING = 'Corporate Training and eLearning',
  CROWD_FUNDING = 'Crowdfunding Platforms',
  CYBER_SECURITY = 'Cyber Security',
  DEFENSE_SYSTEMS = 'Defense Systems and Equipment',
  DIGITAL_BANKING = 'Digital Banking',
  DIGITAL_HEALTH = 'Digital Health and HealthTech',
  DIRECT_TO_CONSUMER = 'Direct-to-Consumer (DTC) Brands',
  DRONES = 'Drones',
  ECOMMERCE = 'E-commerce and Retail Tech',
  EDTECH = 'Education Technology (EdTech)',
  EDUCATION_AND_SKILLING = 'Education and Skilling',
  EDUCATION_MANAGEMENT = 'Education Management Software',
  ELECTRIC_VEHICLES = 'Electric Vehicles (EV) and Batteries',
  ENERGY = 'Energy',
  ENERGY_STORAGE = 'Energy Storage Solutions',
  ENTERPRISE_SAAS = 'Enterprise SaaS',
  ENTERTAINMENT_AND_MEDIA = 'Entertainment & Media',
  ENVIRONMENTAL_MONITORING = 'Environmental Monitoring and Compliance',
  FARM_MANAGEMENT = 'Farm Management Software',
  FINANCE = 'Finance',
  FINTECH = 'Financial Services and FinTech',
  FLEET_MANAGEMENT = 'Fleet Management',
  FOOD_AND_BEVERAGES = 'Food & Beverages',
  FREIGHT_AND_LOGISTICS = 'Freight and Logistics Tech',
  GAMING = 'Gaming',
  GAMING_AND_ESPORTS = 'Gaming and eSports',
  GENERATIVE_AI = 'Generative AI',
  HEALTH_AND_WELLNESS = 'Health and Wellness Products',
  HEALTHCARE = 'Healthcare',
  HEALTHCARE_SERVICES = 'Healthcare Services and Facilities',
  HOTEL_SOLUTIONS = 'Hotel and Accommodation Solutions',
  INDUSTRIAL_IOT = 'Industrial IoT (IIoT)',
  INFRASTRUCTURE = 'Infrastructure',
  INSURANCE_TECH = 'Insurance Technology (InsurTech)',
  INTERNET_OF_THINGS = 'Internet of Things (IoT)',
  K12_SOLUTIONS = 'K-12 and Higher Education Solutions',
  LAST_MILE_DELIVERY = 'Last-Mile Delivery Solutions',
  LIFE_SCIENCES = 'Life Sciences',
  LOYALTY_PROGRAMS = 'Loyalty Programs',
  MANUFACTURING_TECHNOLOGY = 'Manufacturing & Industry 4.0',
  MATERIAL_SCIENCES = 'Material Sciences',
  MEDIA_AND_ENTERTAINMENT = 'Media and Entertainment',
  MEDICAL_DEVICES = 'Medical Devices',
  OMNICHANNEL_RETAIL = 'Omnichannel Retail Solutions',
  ONLINE_LEARNING = 'Online Learning Platforms',
  ONLINE_TRAVEL = 'Online Travel Agencies (OTAs)',
  PAYMENT_SOLUTIONS = 'Payment Solutions',
  PEER_TO_PEER_LENDING = 'Peer-to-Peer Lending',
  PERSONAL_CARE = 'Personal Care and Wellness',
  PHARMACEUTICALS = 'Pharmaceuticals',
  POINT_OF_SALE = 'Point of Sale (POS) Solutions',
  PRECISION_AGRICULTURE = 'Precision Agriculture',
  PROPERTY_FINANCING = 'Property Financing and Lending',
  PROPERTY_MANAGEMENT = 'Property Management Solutions',
  QUANTUM_COMPUTING = 'Quantum Computing',
  REAL_ESTATE = 'Real Estate and PropTech',
  REAL_ESTATE_ANALYTICS = 'Real Estate Analytics',
  REAL_ESTATE_INVESTMENT = 'Real Estate Investment Platforms',
  REGENERATIVE_AGRICULTURE = 'Sustainable Agriculture',
  REG_TECH = 'RegTech (Regulatory Technology)',
  RENEWABLE_ENERGY = 'Renewable Energy (Solar, Wind, Hydro, etc.)',
  RETAIL = 'Retail',
  ROBOTICS = 'Robotics and Automation',
  SKILL_DEVELOPMENT = 'Skill Development Platforms',
  SMART_FACTORIES = 'Smart Factories',
  SMART_HOMES = 'Smart Homes and Buildings',
  SMART_IRRIGATION = 'Smart Irrigation Systems',
  SMART_MANUFACTURING = 'Smart Manufacturing',
  SOCIAL_MEDIA = 'Social Media and Content Creation Tools',
  SPACE_TECHNOLOGY = 'Space Technology and Satellites',
  SPACETECH = 'Spacetech',
  STREAMING_AND_OTT = 'Streaming and OTT Platforms',
  SUBSCRIPTION_SERVICES = 'Subscription Services',
  SUPPLY_CHAIN = 'Supply Chain & Logistics',
  SUSTAINABLE_AGRICULTURE = 'Sustainable Farming Solutions',
  SUSTAINABILITY_AND_ENVIRONMENT = 'Sustainability & Environment',
  TELECOM = 'Telecom',
  TELECOM_SOFTWARE = 'Telecom Software Solutions',
  TELEMEDICINE = 'Telemedicine',
  TEXTILE = 'Textile',
  TOURISM_PLATFORMS = 'Tourism and Experiences Platforms',
  TRAVEL_AND_LEISURE = 'Travel and Leisure',
  UAVS_AND_DRONES = 'UAVs and Drones',
  VACATION_RENTALS = 'Vacation Rental Platforms',
  VIRTUAL_CLASSROOMS = 'Virtual Classrooms',
  WAREHOUSING = 'Warehousing',
  WASTE_MANAGEMENT = 'Waste Management and Recycling',
  WEB3 = 'Web3',
  WEALTH_MANAGEMENT = 'Wealth Management and Robo-Advisors',
  Other = 'Other'
}
export enum SelectedIndustries {
  AI_ML = 'AI/ML',
  AGRICULTURE_FOOD = 'Agriculture & Food',
  BLOCKCHAIN_WEB3 = 'Blockchain &  Web3',
  CONSUMER_PRODUCTS = 'Consumer Products',
  CONSUMER_TECH = 'Consumer Tech',
  DEEP_TECH = 'Deep Tech',
  ECOMMERCE = 'E-commerce',
  EDUCATION = 'Education',
  FINANCE = 'Finance',
  HEALTH = 'Health',
  HOSPITALITY_TRAVEL = 'Hospitality/Travel',
  MANUFACTURING = 'Manufacturing',
  SAAS_ENT_SOFTWARE = 'SaaS/Ent. Software',
  SUPPLY_CHAIN = 'Supply Chain',
  SUSTAINABILITY = 'Sustainibility',
  OTHERS = 'Others',
}
export type TList = { Name: string, Website: string }
export const CoWorkerList: TList[] = [
  {
    "Name": "WeWork",
    "Website": "https://wework.co.in"
  },
  {
    "Name": "Awfis",
    "Website": "https://www.awfis.com"
  },
  {
    "Name": "91springboard",
    "Website": "https://www.91springboard.com"
  },
  {
    "Name": "Innov8",
    "Website": "https://www.innov8.work"
  },
  {
    "Name": "IndiQube",
    "Website": "https://indiqube.com"
  },
  {
    "Name": "AltF",
    "Website": "https://altfcoworking.com"
  },
  {
    "Name": "Smartworks",
    "Website": "https://www.smartworksoffice.com"
  },
  {
    "Name": "WorkEZ",
    "Website": "https://workez.in"
  },
  {
    "Name": "East India Works",
    "Website": "https://eastindiaworks.com"
  },
  {
    "Name": "Cowrks",
    "Website": "https://cowrks.com"
  },
  {
    "Name": "Regus",
    "Website": "https://www.regus.com"
  },
  {
    "Name": "iKeva",
    "Website": "https://ikeva.com"
  },
  {
    "Name": "Workafella",
    "Website": "https://workafella.com"
  },
  {
    "Name": "Nextcoworks",
    "Website": "https://nextcoworks.com"
  },
  {
    "Name": "Co Karma",
    "Website": "https://cokarma.in"
  },
  {
    "Name": "Hatch Station",
    "Website": "https://hatchstation.com/"
  },
  {
    "Name": "Connekt",
    "Website": "https://www.connekt.co.in/"
  },
  {
    "Name": "WorkAdda",
    "Website": "https://www.workaddacoworking.com/"
  },
  {
    "Name": "Adited",
    "Website": "https://adited.com/"
  },
  {
    "Name": "My Place",
    "Website": "https://myplacecoworking.com/"
  },
  {
    "Name": "Summit Space",
    "Website": "https://summitspace.in"
  },
  {
    "Name": "CozyCO",
    "Website": "https://cozycooffice.in/"
  },
  {
    "Name": "Garage",
    "Website": "https://www.thegarage.one/"
  },
  {
    "Name": "GloCal",
    "Website": "https://myhq.in/dedicated/coworking-space/glocal-coworking-space-chandreshnagar"
  },
  {
    "Name": "Green Desks",
    "Website": "https://greendesk.com/"
  },
  {
    "Name": "Hustle Cowork",
    "Website": "https://hustlecowork.com"
  },
  {
    "Name": "IdeaPad",
    "Website": "https://ideapod.in/"
  },
  {
    "Name": "Igloo",
    "Website": "https://igloocoworkingspaces.com/"
  },
  {
    "Name": "Incubex",
    "Website": "https://www.incubex.in/"
  },
  {
    "Name": "Lumos Cowork",
    "Website": "https://co.lumoswork.com/"
  },
  {
    "Name": "Ministry of New",
    "Website": "https://ministryofnew.com"
  },
  {
    "Name": "UnBoxed",
    "Website": "https://unboxedcoworking.com"
  },
  {
    "Name": "Workly",
    "Website": "https://workly.in"
  },
  {
    "Name": "Draper House",
    "Website": "https://draperstartuphouse.com/"
  },
  {
    "Name": "T-Hub",
    "Website": "https://t-hub.co/"
  },
  {
    "Name": "We Hub",
    "Website": "https://wehub.telangana.gov.in/"
  },
  {
    "Name": "Bhive",
    "Website": "https://bhiveworkspace.com/"
  },
  {
    "Name": "Urban Vault",
    "Website": "https://www.urbanvault.in/"
  },
  {
    "Name": "Vatika",
    "Website": "https://www.vatikabusinesscentre.com/co-working/"
  },
  {
    "Name": "Others",
    "Website": ""
  }
]

export const IncubatorList: TList[] = [
  {
    "Name": "VFTBI",
    "Website": "https://www.vishva.co/"
  },
  {
    "Name": "SSIIE-TBI",
    "Website": "https://spmvv-tbi.in/"
  },
  {
    "Name": "MNNIT TBI",
    "Website": "https://www.mnnit.ac.in/tbi/"
  },
  {
    "Name": "CIIE - IIT(ISM) Dhanbad",
    "Website": "https://ciie.iitism.ac.in/"
  },
  {
    "Name": "FIST TBI - IIT Patna",
    "Website": "http://fistiitp.com/"
  },
  {
    "Name": "NITRRFIE - Raipur",
    "Website": "https://www.nitrrfie.in/"
  },
  {
    "Name": "FITT -  IIT Delhi",
    "Website": "https://fitt-iitd.in/"
  },
  {
    "Name": "IIITD-IC",
    "Website": "https://iiitdic.in/"
  },
  {
    "Name": "ILF",
    "Website": "https://indigramlabs.org/"
  },
  {
    "Name": "IGDTUW – Anveshan Foundation",
    "Website": "https://www.anveshanfoundation.org/"
  },
  {
    "Name": "Pusa Krishi",
    "Website": "https://pusakrishi.in/"
  },
  {
    "Name": "CIBA",
    "Website": "https://www.ciba.org.in/"
  },
  {
    "Name": "iCreate",
    "Website": "https://www.icreate.org.in/"
  },
  {
    "Name": "CrAdLE",
    "Website": "https://cradle-edii.in/"
  },
  {
    "Name": "GUSEC",
    "Website": "https://gusec.edu.in/"
  },
  {
    "Name": "IIPHG-NIDHI-TBI",
    "Website": "https://iiphgtbi.org/"
  },
  {
    "Name": "LEAF - TBI",
    "Website": "https://www.glsleaf.in/"
  },
  {
    "Name": "NIF-ientreC",
    "Website": "https://nif.org.in/NIF-ientreC"
  },
  {
    "Name": "VentureStudio - Ahemdabad",
    "Website": "https://ahduni.edu.in/academics/schools-centres/venturestudio/"
  },
  {
    "Name": "NDBI",
    "Website": "https://www.ndbiindia.org/"
  },
  {
    "Name": "IIEC -IITGN",
    "Website": "https://iieciitgn.com/"
  },
  {
    "Name": "IITGNRP",
    "Website": "https://iitgnrp.com/"
  },
  {
    "Name": "IIMA Ventures",
    "Website": "https://iimaventures.com/"
  },
  {
    "Name": "ASHINE",
    "Website": "https://ashine.in/"
  },
  {
    "Name": "PDEU IIC",
    "Website": "https://iic.pdeu.ac.in/"
  },
  {
    "Name": "STBI",
    "Website": "https://stbi.gujarat.gov.in/"
  },
  {
    "Name": "Nirma Incubator",
    "Website": "https://cenu.nirmauni.ac.in/nirmauniversityincubationcentre/"
  },
  {
    "Name": "EPIC",
    "Website": "https://www.epicambala.com/"
  },
  {
    "Name": "IIT Mandi Catalyst",
    "Website": "https://www.iitmandicatalyst.in/"
  },
  {
    "Name": "IIT Mandi iHub",
    "Website": "https://www.ihubiitmandi.in/"
  },
  {
    "Name": "TBI IIIM Jammu",
    "Website": "https://www.iiimtbi.com/"
  },
  {
    "Name": "SMVDU - TBIC",
    "Website": "https://tbic.smvdu.ac.in/"
  },
  {
    "Name": "BIT -STEP",
    "Website": "https://bitmesra.ac.in/display/content/1/357"
  },
  {
    "Name": "ARTILAB Foundation",
    "Website": "https://www.100x.vc/incubator-partners/artilab-foundation-bengaluru"
  },
  {
    "Name": "BESST-HOST",
    "Website": "https://www.bessthort.in/"
  },
  {
    "Name": "DERBI Foundation",
    "Website": "https://derbifoundation.com/"
  },
  {
    "Name": "Social Alpha",
    "Website": "https://www.socialalpha.org/"
  },
  {
    "Name": "GINSERV",
    "Website": "https://www.ginserv.in/"
  },
  {
    "Name": "IKP EDEN - TBI",
    "Website": "https://ikpeden.com/"
  },
  {
    "Name": "JUiNCUBATOR",
    "Website": "https://www.juincubator.com/"
  },
  {
    "Name": "JSSATE  - Bangalore",
    "Website": "https://jssateb.ac.in/pview/step"
  },
  {
    "Name": "KLE-CTIE",
    "Website": "https://klectie.com/"
  },
  {
    "Name": "MUTBI",
    "Website": "https://www.manipal.edu/mu/important-links/innovation-entrepreneruship/mutbi.html"
  },
  {
    "Name": "MSMF - TBI",
    "Website": "https://tbi.ms-mf.org/"
  },
  {
    "Name": "SJCE-STEP",
    "Website": "https://www.sjcestep.in/about-us"
  },
  {
    "Name": "Despande Startups",
    "Website": "https://deshpandestartups.org/"
  },
  {
    "Name": "NITK STEP",
    "Website": "https://step.nitk.ac.in/"
  },
  {
    "Name": "BEC STEP",
    "Website": "https://www.becbgk.edu/STEP/STEP_Home.php"
  },
  {
    "Name": "Technovate for India",
    "Website": "https://technovateforindia.com/"
  },
  {
    "Name": "SCTIMST-TIMed",
    "Website": "https://tips.timed.org.in/about-timed/"
  },
  {
    "Name": "NIT Calicut - TBI",
    "Website": "https://nitc.ac.in/technology-business-incubator"
  },
  {
    "Name": "Amrita TBI",
    "Website": "https://www.amritatbi.com/"
  },
  {
    "Name": "Startups Valley Kerala",
    "Website": "http://startupsvalley.in/"
  },
  {
    "Name": "KSUM - TBI",
    "Website": "https://startupmission.kerala.gov.in/programs/csr/ksum.html"
  },
  {
    "Name": "Startup Village",
    "Website": "https://sv.co/"
  },
  {
    "Name": "IIMK LIVE",
    "Website": "https://www.iimklive.org/"
  },
  {
    "Name": "IISER - Bhopal",
    "Website": "https://iice.iiserb.ac.in/"
  },
  {
    "Name": "SINE - IITB",
    "Website": "https://sineiitb.org/"
  },
  {
    "Name": "BIL - Ryerson TBI",
    "Website": "https://discover.give.do/TGP/bil-ryerson-technology-startup-incubator-foundation/"
  },
  {
    "Name": "CIBA Goa",
    "Website": "https://ciba.org.in/"
  },
  {
    "Name": "COEP Bhau",
    "Website": "https://bhau.org/"
  },
  {
    "Name": "DKTE IIC",
    "Website": "https://www.dkte.ac.in/iic"
  },
  {
    "Name": "Venture Center",
    "Website": "https://www.venturecenter.co.in/"
  },
  {
    "Name": "Raisoni Found.",
    "Website": "https://ghrtbi.com/"
  },
  {
    "Name": "MIT WPU TBI",
    "Website": "https://mittbi.org/"
  },
  {
    "Name": "RIIDL",
    "Website": "https://riidl.org/"
  },
  {
    "Name": "Sardar Patel TBI",
    "Website": "https://www.sptbi.com/"
  },
  {
    "Name": "SCEI-Symbiosis",
    "Website": "https://scei.org.in/"
  },
  {
    "Name": "VJTI TBI",
    "Website": "https://vjti-tbi.in/"
  },
  {
    "Name": "BETIC",
    "Website": "https://www.betic.org/"
  },
  {
    "Name": "MITCON TBI",
    "Website": "https://mitconbiopharma.com/mitcon-technology-business-incubator-consultancy-services/"
  },
  {
    "Name": "Mizoram Uni Incubator",
    "Website": "https://incubemzu.com/"
  },
  {
    "Name": "CVRCE TBI",
    "Website": "https://cgu-odisha.ac.in/cvrce-technology-incubator-foundation/"
  },
  {
    "Name": "FTBI NITRKL",
    "Website": "https://www.ftbi-nitrkl.org/"
  },
  {
    "Name": "KIIT Incubator",
    "Website": "https://kiitincubator.in/"
  },
  {
    "Name": "IITRPR TBI",
    "Website": "https://www.iitrpr.ac.in/tbif/"
  },
  {
    "Name": "IISER Mohali TBI",
    "Website": "https://www.iisermohali.ac.in/research/technology-business-incubator"
  },
  {
    "Name": "NITJ- TBI",
    "Website": "https://nitj.ac.in/research/TechnologyBusinessIncubator.html"
  },
  {
    "Name": "Chandigarh Uni TBI",
    "Website": "https://www.cuchd.in/research/tbi.php"
  },
  {
    "Name": "STEP TIET",
    "Website": "https://www.thapar.edu/academics/centers/science-technology-entrepreneurs-park-step"
  },
  {
    "Name": "LPU Incubator",
    "Website": "https://www.lpu.in/campus-life/entrepreneurship.php"
  },
  {
    "Name": "PAU TBI",
    "Website": "https://www.pau-campus.com/coa/index.php?_act=manageDepartments&DO=viewMatter&intDepTitleID=447&intLinkID=6&strDepTitle=NIDHI%20-%20Technology%20Business%20Incubator"
  },
  {
    "Name": "STEP GNDEC",
    "Website": "https://stepgndec.com/"
  },
  {
    "Name": "IIMU Incubator",
    "Website": "https://iimuic.org/"
  },
  {
    "Name": "MNIT MIIC",
    "Website": "https://miic.mnit.ac.in/"
  },
  {
    "Name": "PIEDS BITS Pilani",
    "Website": "https://pieds-bitspilani.org/"
  },
  {
    "Name": "IITM Incubation",
    "Website": "https://www.iitm.ac.in/research-park/incubation-cell"
  },
  {
    "Name": "RTBI",
    "Website": "http://hrm.rtbi.in/"
  },
  {
    "Name": "MaDeIT IIITDM",
    "Website": "http://www.madeit.iiitdm.ac.in/"
  },
  {
    "Name": "TREC-STEP",
    "Website": "https://www.trecstep.com/"
  },
  {
    "Name": "TBI-ABIS",
    "Website": "https://www.tbitnau.com/"
  },
  {
    "Name": "DETI ACE",
    "Website": "https://www.detiaceprayas.org.in/"
  },
  {
    "Name": "BIT-TBI",
    "Website": "https://bittbi.com/"
  },
  {
    "Name": "Forge-IV",
    "Website": "https://www.forge-iv.co/"
  },
  {
    "Name": "CIET TBI",
    "Website": "https://www.cietcbe.edu.in/"
  },
  {
    "Name": "SASTRA-TBI",
    "Website": "https://sastratbi.in/"
  },
  {
    "Name": "NGI TBI",
    "Website": "https://ngitbi.com/"
  },
  {
    "Name": "Periyar TBI",
    "Website": "https://periyartbi.pmu.edu/"
  },
  {
    "Name": "NRIIC",
    "Website": "http://www.psgstep.org/index.php?page_id=4&sub_id=194"
  },
  {
    "Name": "Sathyabama TBI",
    "Website": "https://www.sathyabama.ac.in/Centre_for_Innovation_and_Technology_Transfer"
  },
  {
    "Name": "SPEC-TBI",
    "Website": "https://www.spectbi.com/"
  },
  {
    "Name": "TCE-TBI",
    "Website": "https://www.tce.edu/tbi"
  },
  {
    "Name": "IIT BBS REP",
    "Website": "https://rep.iitbbs.ac.in/"
  },
  {
    "Name": "Uni of Madras",
    "Website": "https://www.unom.ac.in/index.php?route=miscelleneous/tbi"
  },
  {
    "Name": "KEC-TBI",
    "Website": "https://www.tbi-kec.org/"
  },
  {
    "Name": "VelTech TBI",
    "Website": "https://www.veltechtbi.com/"
  },
  {
    "Name": "VIIT-TBI",
    "Website": "https://vittbi.com/"
  },
  {
    "Name": "Villgro",
    "Website": "https://villgro.org/"
  },
  {
    "Name": "Bharath TBI",
    "Website": "https://bharathtbi.bharathuniv.ac.in/"
  },
  {
    "Name": "AU-TEC Incubator",
    "Website": "https://ctdt.annauniv.edu/dst_tec_1/startups/about.html"
  },
  {
    "Name": "i-TIC IITH",
    "Website": "https://itic.iith.ac.in/"
  },
  {
    "Name": "a-IDEA NAARM",
    "Website": "https://aidea.naarm.org.in/"
  },
  {
    "Name": "ICRISAT",
    "Website": "https://www.icrisat.org/services/business-incubation"
  },
  {
    "Name": "ASPIRE-TBI",
    "Website": "https://tbi.uohyd.ac.in/"
  },
  {
    "Name": "BITS TBI",
    "Website": "https://www.bits-pilani.ac.in/hyderabad/tbi/"
  },
  {
    "Name": "IKP-LSI",
    "Website": "https://ikpknowledgepark.com/"
  },
  {
    "Name": "dlabs ISB",
    "Website": "https://isbdlabs.org/"
  },
  {
    "Name": "NIELAN TBI",
    "Website": "https://www.millets.res.in/nielan-tbi.php"
  },
  {
    "Name": "JNTUH TBI",
    "Website": "https://jntuhtbi.in/"
  },
  {
    "Name": "SIDBI SIIC",
    "Website": "https://siicincubator.com/"
  },
  {
    "Name": "MCIIE IITBHU",
    "Website": "https://www.indiascienceandtechnology.gov.in/innovations/incubators/malviya-centre-innovation-incubation-and-entrepreneurship-mciie-indian-institute-technology-bhu"
  },
  {
    "Name": "IIML EIC",
    "Website": "https://www.iimlincubator.com/"
  },
  {
    "Name": "Amity Incubator",
    "Website": "https://www.amity.edu/aii/"
  },
  {
    "Name": "JSSATE STEP",
    "Website": "https://jssateb.ac.in/pview/step"
  },
  {
    "Name": "TBI KIET",
    "Website": "https://tbi-kiet.in/"
  },
  {
    "Name": "FIED",
    "Website": "https://fied.in/"
  },
  {
    "Name": "TIEDS IITR",
    "Website": "https://tides.iitr.ac.in/"
  },
  {
    "Name": "TBI-GEU",
    "Website": "https://tbi.geu.ac.in/"
  },
  {
    "Name": "IIMCIP",
    "Website": "https://iimcip.org/"
  },
  {
    "Name": "STEP IITKGP",
    "Website": "https://www.stepiitkgp.org/"
  },
  {
    "Name": "RISE IISER",
    "Website": "https://risefoundationiiser.co.in/"
  },
  {
    "Name": "PSG-STEP",
    "Website": "http://www.psgstep.org/"
  },
  {
    "Name": "Math Hub",
    "Website": "https://www.mat-hub.ai/"
  },
  {
    "Name": "SIIC IITK",
    "Website": "https://siicincubator.com/"
  },
  {
    "Name": "T-Hub",
    "Website": "https://t-hub.co/"
  },
  {
    "Name": "iCreate",
    "Website": "https://www.icreate.org.in/"
  },
  {
    "Name": "SIIR",
    "Website": "https://www.shriraminstitute.org/technology-business-incubators/"
  },
  {
    "Name": "Zone startups",
    "Website": "https://india.zonestartups.com/"
  },
  {
    "Name": "SRiX",
    "Website": "https://www.srix.in/"
  },
  {
    "Name": "Villgro",
    "Website": "https://villgro.org/"
  },
  {
    "Name": "IIMV FIELD",
    "Website": "https://iimvfield.com/"
  },
  {
    "Name": "C-CAMP",
    "Website": "https://ccamp.res.in/"
  },
  {
    "Name": "CIE IITH",
    "Website": "https://cie.iiit.ac.in/"
  },
  {
    "Name": "Maker Village",
    "Website": "https://makervillage.in/"
  },
  {
    "Name": "VJ Hub",
    "Website": "https://vjhub.in/"
  },
  {
    "Name": "Woxsen",
    "Website": "https://woxsen.edu.in/campus-life/trade-tower/"
  },
  {
    "Name": "TiE Global",
    "Website": "https://delhi.tie.org/partner-incubators/incubator-services/"
  },
  {
    "Name": "VIBA",
    "Website": "https://www.vibafoundation.com/"
  },
  {
    "Name": "Nutri hub",
    "Website": "https://www.nutrihubiimr.com/"
  },
  {
    "Name": "Edventure Park",
    "Website": "https://edventurepark.com/"
  },
  {
    "Name": "Aspire Bionest",
    "Website": "https://bionest.uohyd.ac.in/"
  },
  {
    "Name": "Prime Venture",
    "Website": "https://www.primevp.in/"
  },
  {
    "Name": "I-Venture",
    "Website": "https://i-venture.org/"
  },
  {
    "Name": "NASSCOM",
    "Website": "https://10000startups.com/"
  },
  {
    "Name": "Marwari Catalysts",
    "Website": "https://www.marwaricatalysts.com/"
  },
  {
    "Name": "T-Works",
    "Website": "https://tworks.telangana.gov.in/"
  },
  {
    "Name": "NSRCEl",
    "Website": "https://nsrcel.org/"
  },
  {
    "Name": "AIC Mahindra",
    "Website": "https://www.mahindrauniversity.edu.in/aic/"
  },
  {
    "Name": "AIC GNITS",
    "Website": "https://aicgnits.infinityfreeapp.com/"
  },
  {
    "Name": "ACIC CBIT",
    "Website": "https://acic-cbit.in/incubation.php"
  },
  {
    "Name": "AIC-JKLU",
    "Website": "https://www.aicjklu.in/"
  },
  {
    "Name": "AIC-Nalanda",
    "Website": "https://www.aicnalanda.com/"
  },
  {
    "Name": "AIC-AARTECH",
    "Website": "https://aic-aartech.in/"
  },
  {
    "Name": "AIC-ADTB",
    "Website": "https://www.aicadtbaramatifoundation.org/"
  },
  {
    "Name": "Scoial Alpha",
    "Website": "https://www.socialalpha.org/about-us/"
  },
  {
    "Name": "AIC-GIM",
    "Website": "https://www.aicgim.in/"
  },
  {
    "Name": "AIC-GISC",
    "Website": "https://aicgisc.org/"
  },
  {
    "Name": "AIC-BIMTECH",
    "Website": "https://aicbimtech.com/"
  },
  {
    "Name": "AIC-RNTU",
    "Website": "https://www.aicrntu.com/"
  },
  {
    "Name": "AIC-NMIMS",
    "Website": "https://aic.nmims.edu/"
  },
  {
    "Name": "AIC-Banasthali",
    "Website": "https://www.aicbanasthali.org/"
  },
  {
    "Name": "AIC-MUJ",
    "Website": "https://www.aicmuj.com/"
  },
  {
    "Name": "AIC-PINNACLE",
    "Website": "https://www.aic-pinnacle.org/"
  },
  {
    "Name": "AIC-DSU",
    "Website": "https://aicdsu.foundation/"
  },
  {
    "Name": "AIC-CCMB",
    "Website": "https://aic.ccmb.res.in/"
  },
  {
    "Name": "AIC-MIT ADT",
    "Website": "https://aic.mituniversity.ac.in/"
  },
  {
    "Name": "AIC-Prestige",
    "Website": "https://aic-prestigeinspirefoundation.in/"
  },
  {
    "Name": "AIC-MFIE-IM-BHU",
    "Website": "https://www.linkedin.com/company/aicbhu/"
  },
  {
    "Name": "Others",
    "Website": ""
  }
]

export enum Services {
  PRODUCT_DEVELOPMENT = 'Product Development',
  LEGAL_AND_COMPLIANCE = 'Legal & compliance',
  MARKETING_AND_BRANDING = 'Marketing & Branding',
  HUMAN_RESOURCES = 'Human Resoucres',
  ACCOUNTING_AND_FINANCE = 'Accounting & Finance',
  COWORKING_AND_FACILITIES = 'Coworking & Facilities',
  HARDWARE_PROCUREMENT_AND_LEASING = 'Hardware Procurement & Leasing'
}

export enum Profession {
  STUDENT = 'Student',
  WORKING_PROFESSIONAL = 'Working Professional',
  OTHER = 'Other'
}

export type TUserTypes = 'User' | 'Company';
